<template>
    <v-sheet class="desc-node">
        <v-card-title :class="`desc-node__title ${color} lighten-5`">
            <span> {{ title }} </span>
            <v-spacer />
            <v-btn small text icon class="my-n2" @click="pull">
                <v-icon> mdi-trash-can-outline </v-icon>
            </v-btn>
            <v-btn small text icon class="my-n2 mr-n2" @click="exit">
                <v-icon> mdi-close </v-icon>
            </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
            <component :is="`node-${form?.type?.toLowerCase?.()}`" v-model="form" @input="emit" />
        </v-card-text>
    </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import { EMPLOYMENT_FIELD_SIDES, EMPLOYMENT_FIELD_TYPES, initEmploymentField } from "@/assets/variables";

import NodeCbox from "./node/node-cbox.vue";
import NodeDate from "./node/node-date.vue";
import NodeSign from "./node/node-sign.vue";
import NodeText from "./node/node-text.vue";

export default {
    components: {
        NodeCbox,
        NodeDate,
        NodeSign,
        NodeText,
    },
    data: () => ({
        form: initEmploymentField(),
    }),
    computed: {
        ...mapState("employment/form/node", ["active"]),
        title() {
            return EMPLOYMENT_FIELD_TYPES[this.form.type]?.text;
        },
        color() {
            return EMPLOYMENT_FIELD_SIDES[this.form.side]?.color;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        active() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.active);
        },
        emit() {
            this.$store.dispatch("employment/form/node/updateItem", this.form);
        },
        pull() {
            this.$store.dispatch("employment/form/node/pullItem", this.form);
        },
        exit() {
            this.$store.commit("employment/form/node/setIsEdit", false);
        },
    },
};
</script>

<style lang="scss" scoped>
.desc-node {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__title {
        font-size: 16px !important;
        height: 60px;
    }
}
</style>
